import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d2978274"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/8da29f72-4100-d766-b82e-f7d157abca6f.png",
  alt: "logo",
  class: "title-logo"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "header title"
}, "小河治街管理系统", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "notice"
}, "通知", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_badge = _resolveComponent("el-badge");
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_header = _resolveComponent("el-header");
  const _component_AsideMenu = _resolveComponent("AsideMenu");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "header"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "header left"
        }, {
          default: _withCtx(() => [_hoisted_2, _hoisted_3]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "header right"
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "ring"
          }), _createVNode(_component_el_badge, {
            value: 12,
            class: "notice_dot"
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          }), _createVNode(_component_el_popover, {
            trigger: "click"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_avatar, {
              size: 33,
              "src-set": _ctx.$store.state.user.avatar
            }, null, 8, ["src-set"])]),
            default: _withCtx(() => [_ctx.$store.state.user.iam != null ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              style: {
                "margin-bottom": "12px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "secondary",
                style: {
                  "width": "100%"
                },
                onClick: $options.unbindIAM
              }, {
                default: _withCtx(() => [_createTextVNode("解绑浙政钉")]),
                _: 1
              }, 8, ["onClick"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                style: {
                  "width": "100%"
                },
                onClick: $options.logout
              }, {
                default: _withCtx(() => [_createTextVNode("退出登录")]),
                _: 1
              }, 8, ["onClick"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_container, {
      class: "container"
    }, {
      default: _withCtx(() => [_createVNode(_component_AsideMenu), _createVNode(_component_el_main, {
        class: "main-view"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}